//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import _ from "js/underscore-mixins";

(function() {
  angular.module('curalate').service('SocialFilterAliasHelper', [
    'CONTENT_LIBRARY_SOURCES_GROUPS',
    'SEARCH_FILTERS',
    'SearchFilterService',
    'SocialSearchBarService',
    function(
            CONTENT_LIBRARY_SOURCES_GROUPS,
            SEARCH_FILTERS,
            SearchFilterService,
            SocialSearchBarService,
        ) {
            /**
             * Registers filter option aliases with the COLLECTION_CONTENT_FILTERS filter set for the provided social filters object.
             * @param {Object[]} socialFilters
             * @param {string} socialFilters[].value - filter value
             * @param {string} socialFilters[].type - ContentFilterTypes.HASHTAG, ContentFilterTypes.USERNAME
             */
      this.registerSocialFilterAliases = (socialFilters) => {
        SearchFilterService.getObservableForFilterSet(SEARCH_FILTERS.COLLECTION_CONTENT_FILTERS).take(1).subscribe(() => {
                    // need to wait for the filter set to exist before registering aliases
          _(socialFilters).each((socialFilter) => {
            const alias = SocialSearchBarService.generatePrefixedString(socialFilter);
            SearchFilterService.registerFilterOptionAlias(
                            SEARCH_FILTERS.COLLECTION_CONTENT_FILTERS,
                            'socialFilters',
                            socialFilter.value,
                            alias,
                        );
          });
        });
      };
    },
  ]);
})();
